import createIcon from '../../createIcon';

/**
 * @component @name AttachMoney
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMzkwMiAxMC45QzEwLjEyMDIgMTAuMzEgOS4zOTAxNiA5LjcgOS4zOTAxNiA4Ljc1QzkuMzkwMTYgNy42NiAxMC40MDAyIDYuOSAxMi4wOTAyIDYuOUMxMy44NzAyIDYuOSAxNC41MzAyIDcuNzUgMTQuNTkwMiA5SDE2LjgwMDJDMTYuNzMwMiA3LjI4IDE1LjY4MDIgNS43IDEzLjU5MDIgNS4xOVYzSDEwLjU5MDJWNS4xNkM4LjY1MDE2IDUuNTggNy4wOTAxNiA2Ljg0IDcuMDkwMTYgOC43N0M3LjA5MDE2IDExLjA4IDkuMDAwMTYgMTIuMjMgMTEuNzkwMiAxMi45QzE0LjI5MDIgMTMuNSAxNC43OTAyIDE0LjM4IDE0Ljc5MDIgMTUuMzFDMTQuNzkwMiAxNiAxNC4zMDAyIDE3LjEgMTIuMDkwMiAxNy4xQzEwLjAzMDIgMTcuMSA5LjIyMDE2IDE2LjE4IDkuMTEwMTYgMTVINi45MTAxNkM3LjAzMDE2IDE3LjE5IDguNjcwMTYgMTguNDIgMTAuNTkwMiAxOC44M1YyMUgxMy41OTAyVjE4Ljg1QzE1LjU0MDIgMTguNDggMTcuMDkwMiAxNy4zNSAxNy4wOTAyIDE1LjNDMTcuMDkwMiAxMi40NiAxNC42NjAyIDExLjQ5IDEyLjM5MDIgMTAuOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AttachMoney = createIcon('AttachMoney', [
  [
    'path',
    {
      d: 'M12.3902 10.9C10.1202 10.31 9.39016 9.7 9.39016 8.75C9.39016 7.66 10.4002 6.9 12.0902 6.9C13.8702 6.9 14.5302 7.75 14.5902 9H16.8002C16.7302 7.28 15.6802 5.7 13.5902 5.19V3H10.5902V5.16C8.65016 5.58 7.09016 6.84 7.09016 8.77C7.09016 11.08 9.00016 12.23 11.7902 12.9C14.2902 13.5 14.7902 14.38 14.7902 15.31C14.7902 16 14.3002 17.1 12.0902 17.1C10.0302 17.1 9.22016 16.18 9.11016 15H6.91016C7.03016 17.19 8.67016 18.42 10.5902 18.83V21H13.5902V18.85C15.5402 18.48 17.0902 17.35 17.0902 15.3C17.0902 12.46 14.6602 11.49 12.3902 10.9Z',
      key: 'z5g1vp',
    },
  ],
]);

export default AttachMoney;
